import React from "react";
const PopupDialog = (props)=>{

    return (
        <div className="popup-dialog">
            <div className="dialog-container">
                <span className="closebtn" onClick={props.handleClose}>
                    &times;
                </span>

                {props.children}
            </div>
        </div>
    );

};

export default PopupDialog;